export default __webpack_public_path__ + "static/media/filling_9.6f1b08ee.jpg";